module.exports = __webpack_public_path__ + "comp-5.png?7fed2187b9c9f4e6be6950a0ca9380b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/comp-5.png
// module id = epzU
// module chunks = 50